import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Lottie from "lottie-react";
import contact from "./../lottie/contact.json";
import { motion } from "framer-motion";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
// import Navbar from '../components/Navbar';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_amfjtue', 'template_160nyyz', form.current, '4Qd-bmC-JcWanF_4z')
      .then((result) => {
        console.log(result.text);
        toast.success('Message sent successfully!', {
          autoClose: 5000,
          position: toast.POSITION.TOP_RIGHT
        });
        form.current.reset();
      })
      .catch((error) => {
        console.log(error.text);
        toast.error('Failed to send message. Please try again later.', {
          autoClose: 5000,
          position: toast.POSITION.TOP_RIGHT
        });
      });
  };

  return (
    <div className='w-full bg-[#2A2A2A]  h-auto  flex'>
      <Link to="/" className='flex items-center justify-center pl-4 pt-12  '><button className='bg-gradient-to-r bg-yellow-400  hover:bg-red-600   h-12 w-32 rounded-full font-bold tracking-widest'><span className='bg-transparent font-bold'>&lt;</span> Home</button></Link>
      <div className='row w-full p-10 flex flex-col md:flex-row lg:flex-row'>
      <motion.div
      initial={{ x: -400 }}
      animate={{ x: 0,
        transition: { duration: 1.2, ease: 'easeOut' } }}
      className='col-md-6 w-full flex items-center justify-center'>
        <Lottie className='-rotate-12 h-5/6 w-3/4' animationData={contact} />
      </motion.div>

      <motion.div
      initial={{ x: 400 }}
      animate={{ x: 0,
        transition: { duration: 1.2, ease: 'easeOut' } }}
      className='col-md-6 w-full'>
        <div className='flex  flex-col items-center justify-center h-full gap-4'>
        <form ref={form} onSubmit={sendEmail} className="w-full flex  flex-col gap-4">
          <label
          className="flex items-center justify-center w-full text-center h-16 font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-300 via-orange-500 to-red-800 ">Contact Me</label>
          <label 
          className="text-yellow-600 font-bold tracking-widest text-lg">Your Name</label>
          <input type="text" name="user_name" className="bg-[#3A3A3A] text-white rounded p-2" />
          <label className="text-yellow-600 font-bold tracking-widest text-lg">Your Email</label>
          <input type="email" name="user_email" className="bg-[#3A3A3A] text-white rounded p-2" />
          <label className="text-yellow-600 font-bold tracking-widest text-lg">Message</label>
          <textarea name="message" className="bg-[#3A3A3A]  text-white rounded p-2" rows="10"></textarea>
          <input type="submit" value="Send" className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-lg tracking-widest px-4 py-2 rounded cursor-pointer" />
        </form>
        </div>
        <ToastContainer />
      </motion.div>
      </div>
      

    </div>
  );
};

export default Contact;



        